/* eslint-disable import/no-cycle */
import {
	LOGIN, LOGOUT, RECOVER_PASSWORD
} from './types';
import { API, removeTokens, saveTokens } from '../services/API';
import {
	LOGIN_PATH, LOGOUT_PATH, RECOVER_PASSWORD_INSPECTOR_PATH, RECOVER_PASSWORD_SUPERVISOR_PATH, RECOVER_PASSWORD_ADMIN_PATH
} from '../services/paths';
import { getUser } from './user';
import { showMessage } from '../utils/messageUtils';
import { ERROR, SUCCESS } from '../utils/constants';
import { LOGIN_ROUTE, RESET_PASSWORD_ROUTE } from '../routing/paths';

const login = ({ email, password }, callback) => (dispatch) => dispatch({
	type: LOGIN,
	promise: API.post(LOGIN_PATH, { email, password }),
	meta: {
		onSuccess: (response) => {
			const accessToken = response.data.user.accessToken;
			const needPasswordReset = response.data.user.needPasswordReset;
			saveTokens({ accessToken });
			dispatch(getUser());
			if (needPasswordReset) {
				window.location = RESET_PASSWORD_ROUTE;
			} else {
				callback();
			}
		},
		onFailure: (error) => showMessage({ type: ERROR, msg: error?.response?.data?.message })
	}
});

const logout = () => (dispatch) => dispatch({
	type: LOGOUT,
	promise: API.post(LOGOUT_PATH),
	meta: {
		onSuccess: () => {
			window.location = LOGIN_ROUTE;
			removeTokens()
		}

	}
});

const recoverPassword = ({ newPassword }, callback, userType) => (dispatch) => dispatch({
	type: RECOVER_PASSWORD,
	promise: API.patch(
		userType == "admin" ? RECOVER_PASSWORD_ADMIN_PATH : userType == "overseer" ? RECOVER_PASSWORD_SUPERVISOR_PATH : RECOVER_PASSWORD_INSPECTOR_PATH
		, { newPassword }),
	meta: {
		onSuccess: (res) => {
			logout()
			callback();
			showMessage({ type: SUCCESS, msg: res?.data.message });
		},
		onFailure: (error) => showMessage({ type: ERROR, msg: error?.response?.data?.message })
	}
});

export {
	login,
	logout,
	recoverPassword
};
